var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", [
    _c("path", {
      attrs: {
        d: "M46.719 55.26c.931 0 1.716-.327 2.355-.983.638-.655.957-1.432.957-2.329V13.854c0-.931-.319-1.716-.957-2.354-.639-.639-1.424-.958-2.355-.958h-9.886V7.333c0-1.346-.483-2.51-1.45-3.494-.965-.983-2.139-1.475-3.519-1.475H25.24c-1.38 0-2.553.492-3.52 1.475-.965.984-1.448 2.148-1.448 3.494v3.209h-9.99c-.931 0-1.716.32-2.355.958-.638.638-.957 1.423-.957 2.354v38.094c0 .897.319 1.674.957 2.33.639.655 1.424.983 2.355.983H46.72zM33.52 10.543h-9.938V7.333c0-.449.164-.837.492-1.165a1.592 1.592 0 011.164-.491h6.625c.449 0 .837.164 1.165.491.328.328.492.716.492 1.165v3.209zm13.198 41.406H10.28V13.854h9.99v3.417l.18.828c.121.552.613.828 1.476.828.931 0 1.44-.276 1.527-.828l.129-.828v-3.417h9.938v3.417l.155.828c.103.552.604.828 1.5.828.829 0 1.312-.276 1.45-.828l.207-.828v-3.417h9.886v38.094z",
        fill: "currentColor",
        "fill-rule": "nonzero",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }